export var camelToHyphenated = function (string) {
    return string.replace(/([A-Z])/g, function (g) { return "-" + g[0].toLowerCase(); });
};
//# sourceMappingURL=helpers.js.map